import React, { InputHTMLAttributes } from 'react';
import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

import { colorScheme } from '../../theme';

import SearchIcon from '../../assets/images/icons/search.svg';

const StyledInput = styled(FormControl)`
  padding: 8px 16px;
  border-radius: 8px;
  height: 40px;
  box-sizing: border-box;

  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${colorScheme.input.text};
  border: 1px solid ${colorScheme.input.border};
  background-color: ${colorScheme.input.background};
  border-radius: 0.25rem;
  appearance: none;

  &:hover,
  &:focus {
    border-color: ${colorScheme.input.border} !important;
  }

  &[list] {
    background-image: url('../../../assets/images/icons/datalist-chevron.svg');
    background-repeat: no-repeat;
    background-position: right 8px center;
  }

  &:focus {
    box-shadow: none;
    border-color: ${colorScheme.focus};
  }

  &&&[type='search'] {
    background-image: url(${SearchIcon}) !important;
    background-repeat: no-repeat;
    background-position: left 8px center;
    padding-left: 28px;
    font-size: 0.875rem;
  }
`;

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <StyledInput {...(props as any)} />;
}
